import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Drop-in replacements for next/link + next/navigation that keep the active
// locale prefix. Import Link/redirect/usePathname/useRouter from here, NOT
// from next/* , in any localized page/component.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
